//Returns a list with 2 sublist, one for PR reviewers and 1 for QA reviewers
import {useProductionURL} from "../helper/constants";

export const getReviewersAPI = async (jwt, docketID) => {

    const resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/workflow/get_reviewers?` + new URLSearchParams({
        docket: docketID,
    }), {
        headers: {
            "auth": jwt
        }
    })

    return await resp.json()
}

//Returns a list where each sublist represents one unique comment
export const getAllCommentInfoAPI = async (jwt, docketID) => {

    const resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/workflow/get_comments?` + new URLSearchParams({
        docket: docketID,
    }), {
        headers: {
            "auth": jwt
        }
    })

    return await resp.json()
}

//Post endpoint to change the current reviewer
//Returns if the reviewer change was successful on the backend
export const postChangeReviewerAPI = async (jwt, docketID, trackingNum, newReviewer, isPR) => {

    const resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/workflow/change_reviewers?` + new URLSearchParams({
        docket: docketID,
        tracking: trackingNum,
        reviewer: newReviewer,
        isPR: isPR
    }), {
        method: "PUT",
        headers: {
            "auth": jwt
        }
    })

    return await resp.json()

}

//Post endpoint to change the current reviewer
//Returns if the reviewer change was successful on the backend
export const postCSV_ValidationDataAPI = async (jwt, docketID, data) => {

    const resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/workflow/validate_contents?` + new URLSearchParams({
        docket: docketID
    }), {
        method: "POST",
        headers: {
            "auth": jwt,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })

    return await resp.json()

}

export const getAdminTabsAPI = async (jwt, docket) => {

    const resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/admin/get_tabs?` + new URLSearchParams({
        docket: docket,
    }), {
        headers: {
            "auth": jwt
        }
    })

    return await resp.json()
}